const traffic = {
  't-global-config': 'Configuración Global',
  't-save-config': 'Guardar Config',
  't-time-window': 'Ventana de Tiempo',
  't-time-window-seconds': 'Ventana de Tiempo (s)',
  't-max-download-count': 'Máx. Descargas',
  't-max-retry-count': 'Reintentos Máx.',
  't-global-config-hint': 'Los Partners sin configuración individual utilizarán este valor predeterminado global. Solo aplica a dispositivos mpush.',
  't-circuit-breaker-strategy': 'Estrategia de Disyuntor',
  't-circuit-breaker-enabled': 'Este Partner aplicará una estrategia de disyuntor independiente',
  't-circuit-breaker-disabled': 'Usar configuración global cuando esté desactivado',
  't-config-params': 'Parámetros de Configuración',
  't-time-window-label': 'Ventana de Tiempo',
  't-max-download-label': 'Máx. Descarga',
  't-max-retry-label': 'Reintentos Máx.',
  't-ban-behavior-title': 'Descripción del Comportamiento de Bloqueo',
  't-ban-behavior-desc': 'Reintentos agotados → El dispositivo entra en estado bloqueado → Todas las solicitudes de descarga en la ventana actual devuelven {0}, el dispositivo detiene las descargas',
  't-download-settings': 'Configuración de Descarga',
  't-traffic-mgmt': 'Gestión de Tráfico',
  "t-error-download-settings": "Limitador de velocidad",
  't-add-config': 'Agregar Configuración',
  't-edit-config': 'Editar Configuración',
  't-status-enabled': 'Habilitado',
  't-status-disabled': 'Deshabilitado',
  't-select-partner': 'Por favor seleccione un Partner',
  't-select-partner-required': 'Por favor seleccione un Partner',
  't-fill-time-window': 'Por favor complete la ventana de tiempo',
  't-save-success': 'Guardado exitosamente',
  't-save-failed': 'Error al guardar',
  't-update-success': 'Actualizado exitosamente',
  't-update-failed': 'Error al actualizar',
  't-add-success': 'Agregado exitosamente',
  't-add-failed': 'Error al agregar',
  't-load-failed': 'Error al cargar datos',
  't-second': 's',
  't-times': 'veces',
  't-fill-max-download': 'Por favor complete el número máximo de descargas',
  't-fill-allowed-retry': 'Por favor complete el número de reintentos permitidos',
  't-time-window-range-error': 'La ventana de tiempo debe estar entre 1 y 7200',
  't-max-download-range-error': 'El máximo de descargas debe estar entre 5 y 200',
  't-allowed-retry-range-error': 'El reintento permitido debe estar entre 1 y 20',
  't-traffic-overview': 'Resumen de Tráfico',
  't-monthly-total-traffic': 'Tráfico Total del Mes',
  't-compared-last-month': 'vs mes anterior',
  't-partner-count': 'Cantidad de Partners',
  't-this-month-new': 'nuevos este mes',
  't-over-limit-partner': 'Partners Sobre el Límite',
  't-need-attention': 'Requiere atención',
  't-all-partner': 'Todos los Partners',
  't-all-usage-rate': 'Todas las Tasas de Uso',
  't-current-month-used-traffic': 'Tráfico Usado Este Mes',
  't-traffic-limit': 'Límite de Tráfico',
  't-usage-rate': 'Tasa de Uso',
  't-this-month-download-count': 'Descargas Este Mes',
  't-normal': 'Normal',
  't-about-to-exceed': 'Cerca del Límite',
  't-exceeded': 'Excedido',
  't-unlimited': 'Ilimitado',
  't-unlimited-traffic': 'Tráfico Ilimitado',
  't-view-traffic-detail': 'Ver detalles de tráfico',
  't-download-records': 'Descargas Este Mes',
  't-file-name': 'Nombre de Archivo',
  't-file-size': 'Tamaño de Archivo',
  't-usage-history': 'Historial de Uso de Datos',
  't-data-usage-trend': 'Tendencia de Uso de Datos',
  't-last-30-days-data-usage-trend': 'Tendencia de uso de datos de los últimos 30 días',
  't-used-traffic': 'Tráfico Usado',
  't-last-12-months-traffic-trend': 'Tendencia de Tráfico de los Últimos 12 Meses',
  't-month': 'Mes',
  't-all-months': 'Todos los Meses',
  't-download-count': 'Cantidad de Descargas',
  't-quota-configuration': 'Límites de tráfico',
  't-global-default-config': 'Configuración Global Predeterminada',
  't-global-default-traffic-limit': 'Límite Global Predeterminado de Tráfico',
  't-current-config': 'Configuración Actual',
  't-quota-global-config-hint': 'Los Partners sin configuración individual de límite de tráfico usarán este valor predeterminado. Use 0 para tráfico ilimitado.',
  't-partner-traffic-limit-config': 'Configuración de Límite de Tráfico de Partner',
  't-config-type': 'Tipo de Configuración',
  't-use-global': 'Usar Global',
  't-custom': 'Personalizado',
}

export default traffic
